<template>
  <div id="header_content" class="header_content">
    <Banner v-slot:pinb><slot name="pin"></slot></Banner>
    <HeaderTop></HeaderTop>
  </div>
</template>

<script>
  import Banner from "./common/Banner.vue";
  import HeaderTop from "./common/HeaderTop.vue";
  export default {
    name: "HeaderProject",
    data: function() {
      return {
        mlw: false
      }
    },
    components: { Banner, HeaderTop },
    methods: {
      menuStyle: function(value) {
        this.mlw = value;
      }
    }
  }
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/HeaderProject.vue